import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

interface MileageBadgeProps {
  miles: number;
  type: 'loaded' | 'unloaded';
  simplified?: boolean;
  className?: string;
}
export function MileageBadge({
  miles,
  type,
  simplified = false,
  className,
}: MileageBadgeProps) {
  const symbol = type === 'loaded' ? 'L' : 'UL';
  const formattedMiles = miles === 0 ? 0 : miles.toFixed(0);

  return (
    <div className={className} data-testid={`${type}-mileage-badge`}>
      <Badge
        label={
          simplified
            ? `${symbol}${formattedMiles}`
            : `${formattedMiles} ${type} miles`
        }
        color="blue"
        border
      />
    </div>
  );
}
